import * as React from "react"
import styled from "styled-components"

interface ProfileImageProps {
  src: string
  size?: number
  alt?: string
}

const Image = styled.img<{ size: number }>`
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
  border-radius: 50%;
  object-fit: cover;
  margin-right: ${(props) => props.theme.spacings.medium};
`

const ProfileImage: React.FC<ProfileImageProps> = ({ src, size = 60, alt }) => {
  return <Image src={src} alt={alt} size={size} />
}

export default ProfileImage
